import React, { useCallback } from 'react';
import { useResponsiveSize } from '@bingads-webui-react/with-responsive-size';
import {
  useWizardService,
  WIZARD_EVENTS,
} from '@bingads-webui-react/wizard-core';
import { Dismiss20Regular } from '@fluentui/react-icons';
import {
  Button,
  mergeClasses,
  makeStyles,
  shorthands,
  tokens,
} from '@fluentui/react-components';

const useBasicTopBarStyles = makeStyles({
  stack: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: tokens.colorNeutralBackground4,
    ...shorthands.borderBottom('1px', 'solid', tokens.colorNeutralStroke2),
    ...shorthands.padding('14px', '24px'),
    ...shorthands.gap('8px'),
  },
  title: {
    fontSize: tokens.fontSizeBase500,
    fontWeight: tokens.fontWeightBold,
    lineHeight: tokens.lineHeightBase500,
  },
  'title-s': {
    fontSize: tokens.fontSizeBase400,
    lineHeight: tokens.lineHeightBase400,
  },
  'title-m': {
    fontSize: tokens.fontSizeBase400,
    lineHeight: tokens.lineHeightBase400,
  },
});

interface BasicTopBarProps {
  classes?: {
    root?: string;
  };
  title: string | React.ReactNode;
  hideCloseButton?: boolean;
}

export const BasicTopBar: React.FC<BasicTopBarProps> = (props) => {
  const classes = useBasicTopBarStyles();
  const displayMode = useResponsiveSize();
  const { send } = useWizardService();
  const onCancelClicked = useCallback(() => {
    send(WIZARD_EVENTS.CANCEL);
  }, [send]);

  if (!props.title) {
    return null;
  }

  return (
    <div className={mergeClasses('wizard-top-bar', classes.stack, props.classes?.root)}>
      <div className={mergeClasses('top-bar-title', classes.title, classes[`title-${displayMode}`])}>{props.title}</div>
      {!props.hideCloseButton
        && (
          <Button
            className="top-bar-cancel-button"
            appearance="subtle"
            icon={<Dismiss20Regular />}
            onClick={onCancelClicked}
          />
        )}
    </div>
  );
};
